import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AccountGate } from '../core/auth/account-gate';
import { CtButton } from './button.directive';

/**
 * Invitation à créer un compte, posée à l'endroit où le parcours visiteur
 * s'arrête.
 *
 * Elle énonce la règle au moment utile : la consultation est libre, le compte
 * n'est demandé qu'au passage à l'acte. Annoncer la contrainte avant le clic
 * vaut mieux que de rediriger sans prévenir vers un écran d'inscription, qui est
 * la manière la plus efficace de perdre un visiteur.
 *
 * Le composant s'efface de lui-même dès que l'utilisateur a un compte : les
 * appelants peuvent le poser sans l'entourer d'une condition, donc sans risque
 * de l'afficher à un membre déjà connecté.
 */
@Component({
  selector: 'ct-account-notice',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CtButton],
  template: `
    @if (!gate.hasAccount()) {
      <aside class="ct-notice">
        <p class="ct-notice-title">Créez un compte pour {{ action() }}</p>
        <p class="detail ct-muted">
          Parcourez les producteurs, les produits et les prix autant que vous voulez. Le compte
          n'est demandé qu'au moment de {{ action() }}.
        </p>
        <button type="button" ctButton="primary" block (click)="start()">
          Créer un compte ou se connecter
        </button>
      </aside>
    }
  `,
  styles: `
    .detail {
      font-size: var(--ct-size-sm);
    }
  `,
})
export class CtAccountNotice {
  protected readonly gate = inject(AccountGate);

  /**
   * Action bloquée, à l'infinitif : « commander », « réserver un panier ».
   * Le texte est composé autour, il doit donc rester un verbe.
   */
  readonly action = input<string>('commander');

  protected start(): void {
    this.gate.requireAccount();
  }
}
